import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchBalances } from '@app/store/slices/balancesSlice';

export function useTopUp() {
  const showToaster = useShowToaster();
  const location = useLocation();
  const dispatch = useDispatch();

  const fetchTopUpSettings = async (setResult) => {
    try {
      const res = await instance.get('/balance');
      const currencies = res?.data?.providers?.wirum?.currencies || {};
      const currenciesWithdraw =
        res?.data?.providers?.wirum?.currencies_withdraw || {};
      const options = Object.keys(currencies).map((key) => ({
        label: key,
        value: key,
      }));
      const withdrawOptions = Object.keys(currenciesWithdraw).map((key) => ({
        label: key,
        value: key,
      }));
      setResult({
        options,
        fee: res?.data?.bankWallets?.[0]?.bank?.top_up_fee,
        withdrawOptions,
      });
    } catch (err) {
      showToaster('error', err?.response?.data?.message);
    }
  };

  const topUp = async (data) => {
    const isBalancesPage = location.pathname.includes('/balances');
    try {
      const res = await instance.post('/balance/refill', data);
      if (isBalancesPage) {
        dispatch(fetchBalances());
      }
      return res?.data?.id;
    } catch (err) {
      if (err?.response?.status != 422) {
        showToaster('error', err?.response?.data?.message);
        return false;
      }
      throw err;
    }
  };

  return { fetchTopUpSettings, topUp };
}
